import { ESSNVerificationStatus, schemes, worker_types } from "@zeal/common";
import { z } from "zod";

export const submitWorkerPaycardSSNIDVerificationSchema = z
  .object({
    companyID: schemes.companyID(),
    workerID: schemes.mongoObjectId(),
    forced_result: z
      .enum([ESSNVerificationStatus.approved, ESSNVerificationStatus.declined])
      .optional(),
    profile_information: z.object({
      first_name: schemes.formattedName(),
      last_name: schemes.formattedName(),
      middle_name: z.string().optional(),
      dob: schemes.dob(),
      ssn: schemes.ssn(),
      ssn_again: schemes.ssn(),
      address: z.string(),
      address_line2: z.string().optional(),
      city: z.string(),
      state: z.string(),
      zip: z.string(),
    }),
    id_information: z.object({
      persona_inquiry_id: z.string(),
    }),
    worker_type: z.nativeEnum(worker_types),
  })
  .superRefine((data, ctx) => {
    if (data.profile_information.ssn !== data.profile_information.ssn_again) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Entered SSNs do not match",
        path: ["ssn", "ssn_again"],
      });
    }
  });

export type TSubmitWorkerPaycardSSNIDVerificationRequest = z.infer<
  typeof submitWorkerPaycardSSNIDVerificationSchema
>;
